import { createSelector } from '@reduxjs/toolkit';
import { externalConnectionsForMap } from './external-connections-for-map';

export const externalConnectionsOffNhn = createSelector(externalConnectionsForMap, (externalConnections) =>
  externalConnections.filter((c) => c.connectionType === 'OTHER'),
);
